module.exports = __webpack_public_path__ + "media/country_flags/fi-eb7e048c.png";